import { useEffect, useState } from 'react'
import { isValidEmail } from '@components/inputs/validations'
import { Cookie, getCookie, deleteCookie } from '@lib/utils/cookies'

const isGrammarlyGoDomain = (url: string) => {
  try {
    const parsedUrl = new URL(url)
    return parsedUrl.hostname === 'go.grammarly.com'
  } catch (e) {
    return false
  }
}

const constructPardotUrl = (pardotUrl: string, email: string): string | null => {
  try {
    const decodedUrl = decodeURIComponent(pardotUrl)
    // Validate URL format
    new URL(decodedUrl)
    return `${decodedUrl}?email=${encodeURIComponent(email)}`
  } catch (error) {
    return null
  }
}

export const usePardotCookieAssociation = () => {
  const [email, setEmail] = useState<string | null>(null)
  const [url, setUrl] = useState<string | null>(null)

  useEffect(() => {
    const pardotEmail = getCookie(Cookie.pardotAssociatedEmail)
    const pardotUrl = getCookie(Cookie.pardotAssociatedUrl)

    if (pardotUrl && pardotEmail && isValidEmail(pardotEmail) && isGrammarlyGoDomain(pardotUrl)) {
      setEmail(pardotEmail)
      setUrl(constructPardotUrl(pardotUrl, pardotEmail))
    }
  }, [])

  const cleanup = () => {
    setEmail(null)
    setUrl(null)
    deleteCookie(Cookie.pardotAssociatedEmail)
    deleteCookie(Cookie.pardotAssociatedUrl)
  }

  return { email, url, cleanup }
}
